module.exports = ":host {\n  display: block;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/client-pagination/client-pagination.component.css
// module id = ./src/app/examples/client-pagination/client-pagination.component.css
// module chunks = main